<vshc-dialog
  #dialogRef
  [open]="open"
  (closeTrigger)="closeTrigger.emit()"
  [options]="options"
  [backdropClass]="options?.backdropClass"
  [autoFocus]="false">
  <div class="__wrap">

    <zef-scroll [height]="'100%'" [maxHeight]="'90vh'">
      <div class="c-text-content  c-text-content-pitch  __content">

        <div class="__info">
          @if (!!heading) {
            <h2
              class="__heading"
              [innerHTML]="heading">
            </h2>
          }
          @if (!!description) {
            <div class="__desc-wrap">
              <p
                class="__desc"
                [innerHTML]="description">
              </p>
            </div>
          }
        </div>

        <ng-content />

      </div>
    </zef-scroll>

    @if (!disableCloseButton) {
      <button
        type="button"
        class="__close-button"
        mat-icon-button
        (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    }

  </div>
</vshc-dialog>
